import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { get } from 'lodash-es';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiV2Service } from '../../../core/services/api-v2.service';
import { SupplierManagementHelperService } from '../../../core/services/supplier-management-helper.service';
import {
  FIELDS,
  Modules,
  useLikeOperator,
} from '../../../shared/consts/custom-fields.consts';
import {
  getFormData,
  serialize,
} from '../../../shared/helpers/utilities.helper';
import type { AnyObject } from '../../../shared/models/core.interface';
import { PropertyType } from '../../../shared/models/property.models';
// eslint-disable-next-line unicorn/prevent-abbreviations -- TODO: delete the comment and fix the error
import type { IRequestParams } from '../../../shared/models/request-parameters.models';
import type { ApiResponse } from '../../../shared/models/response';
import {
  saveSupplierFiltersRequestDtoSchema,
  saveSupplierFiltersResponseDtoSchema,
  type SaveSupplierFiltersResponseDto,
  type SlimSupplierFilter,
  type SupplierHeaders,
} from '../models/supplier.models';
import type {
  CheckExcelFieldsRequestData,
  CheckExcelFieldsRequestQueryParameters,
  DownloadImportExcelRequest,
  ExcelCheckResponse,
} from '../modules/categorization/models/import-suppliers.models';

@Injectable({
  providedIn: 'root',
})
export class SuppliersService {
  readonly #http = inject(HttpClient);
  readonly #apiV2Service = inject(ApiV2Service);

  static getFiltersWithCustomFields(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: delete the comment and fix the error
    activeFiltersSearchValues: any,
    // eslint-disable-next-line unicorn/prevent-abbreviations, @typescript-eslint/no-explicit-any -- TODO: delete the comment and fix the error
    filtersObj: any,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument, unicorn/no-array-reduce, unicorn/prevent-abbreviations, @typescript-eslint/no-explicit-any, sonarjs/cognitive-complexity -- TODO: delete the comment and fix the error
    return Object.keys(activeFiltersSearchValues).reduce((acc: any, f) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, unicorn/prevent-abbreviations, @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
      const filterObj = filtersObj[f];
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: delete the comment and fix the error
      const relation = get(filterObj, 'relation');
      const filterValue =
        // @ts-expect-error TODO: delete the comment and fix the error
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
        useLikeOperator[filterObj?.type] ?
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
          `%${activeFiltersSearchValues[f]}%`
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
        : String(activeFiltersSearchValues[f]);

      /* Check if custom field */
      if (relation instanceof Object) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- TODO: delete the comment and fix the error
        const [filterKey] = Object.keys(relation);

        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
        if (!acc[filterKey]) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
          acc[filterKey] = [];
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call -- TODO: delete the comment and fix the error
        acc[filterKey].push(filterValue);
      } else {
        /* Check if static field */
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: delete the comment and fix the error
        const isGlobalRatingField =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
          filterObj && filterObj.name === FIELDS.GLOBAL_RATING;

        if (isGlobalRatingField) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
          if (activeFiltersSearchValues[f]) {
            /* Global rating filter has value make it in format "[from,to]" even if single value supplied */
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
            const value = activeFiltersSearchValues[f] as string;
            const globalRatingValue =
              value.split(',').length > 1 ? value : [value, value].join(',');

            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
            acc[relation] = `[${globalRatingValue}]`;
          } else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
            acc[relation] = activeFiltersSearchValues[f];
          }
        } else {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: delete the comment and fix the error
          acc[relation || f] = filterValue;
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- TODO: delete the comment and fix the error
      return acc;
    }, {});
  }

  static getFiltersRelations(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: delete the comment and fix the error
    activeFiltersSearchValues: any,
    // eslint-disable-next-line unicorn/prevent-abbreviations, @typescript-eslint/no-explicit-any -- TODO: delete the comment and fix the error
    filtersObj: any,
  ) {
    const { CategoricalSelect, CategoricalSelectMultiple } = PropertyType;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument, unicorn/no-array-reduce, unicorn/prevent-abbreviations, @typescript-eslint/no-explicit-any -- TODO: delete the comment and fix the error
    return Object.keys(activeFiltersSearchValues).reduce((acc: any[], f) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: delete the comment and fix the error
      const relation = get(filtersObj, [f, 'relation']);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: delete the comment and fix the error
      const type = get(filtersObj, [f, 'type']);
      /* Check if custom field */
      if (
        relation instanceof Object &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- TODO: delete the comment and fix the error
        ![CategoricalSelect, CategoricalSelectMultiple].includes(type)
      ) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- TODO: delete the comment and fix the error
        const [, field_id] = Object.values(relation);
        acc.push(field_id);
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- TODO: delete the comment and fix the error
      return acc;
    }, []);
  }

  static getFiltersQuerystring(
    config: IRequestParams,
    // eslint-disable-next-line unicorn/prevent-abbreviations -- TODO: delete the comment and fix the error
    activeFiltersObj?: object,
  ) {
    const filter = config?.filter;
    if (filter && activeFiltersObj) {
      config = {
        ...config,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: delete the comment and fix the error
        filter: SuppliersService.getFiltersWithCustomFields(
          filter,
          activeFiltersObj,
        ),
        property_fields_ids: SuppliersService.getFiltersRelations(
          filter,
          activeFiltersObj,
        ),
      };
    }

    const excludedFilters = Object.keys(config?.filter || {});
    return SupplierManagementHelperService.instance.getFilterAsQuerystring(
      config,
      null,
      excludedFilters,
    );
  }

  getSuppliers(
    config: IRequestParams,
    // eslint-disable-next-line unicorn/prevent-abbreviations -- TODO: delete the comment and fix the error
    activeFiltersObj?: object,
  ): Observable<ApiResponse> {
    const queryString = SuppliersService.getFiltersQuerystring(
      config,
      activeFiltersObj,
    );
    return this.#http.get<ApiResponse>(
      `${environment.api.endpoint}/getSuppliers?${queryString}`,
    );
  }

  saveSupplierFilters(
    accountId: number,
    filters: SlimSupplierFilter[],
  ): Observable<SaveSupplierFiltersResponseDto> {
    return this.#apiV2Service.post({
      request: {
        url: {
          apiName: 'api',
          path: '/v2/filter',
        },
        body: {
          type: Modules.Supplier,
          account_id: accountId,
          filters,
        },
        schema: saveSupplierFiltersRequestDtoSchema,
      },
      response: {
        schema: saveSupplierFiltersResponseDtoSchema,
      },
    });
  }

  saveSupplierHeaders(
    supplierHeaders: SupplierHeaders,
  ): Observable<ApiResponse> {
    return this.#http.post<ApiResponse>(
      `${environment.api.endpoint}/list-view-filter`,
      supplierHeaders,
    );
  }

  checkExcelFields(
    postData: CheckExcelFieldsRequestData,
    queryParameters: CheckExcelFieldsRequestQueryParameters,
  ): Observable<ApiResponse<ExcelCheckResponse>> {
    const queryString = serialize(queryParameters);
    const formData = getFormData(postData);

    return this.#http.post<ApiResponse<ExcelCheckResponse>>(
      `${environment.api.endpoint}/import-validation?${queryString}`,
      formData,
    );
  }

  importExcel(postData: AnyObject): Observable<ApiResponse> {
    // eslint-disable-next-line unicorn/prevent-abbreviations -- TODO: delete the comment and fix the error
    const serializedParams = serialize(postData);
    const options = { headers: new HttpHeaders({ Timeout: '900000' }) };

    return this.#http.post<ApiResponse>(
      `${environment.api.endpoint}/bulk-suppliers?${serializedParams}`,
      {},
      options,
    );
  }

  getAccountProperties(accountId: number): Observable<ApiResponse> {
    return this.#http.get<ApiResponse>(
      `${environment.api.endpoint}/properties-header-data/${accountId}`,
    );
  }

  downloadImportExcel(data: DownloadImportExcelRequest): Observable<Blob> {
    const queryString = serialize(data);
    return this.#http.get(
      `${environment.api.endpoint}/properties/excel-template?${queryString}`,
      {
        responseType: 'blob',
      },
    );
  }
}
